
import { useEffect, useState } from "react";
import { Spin, notification } from "antd";
import { WifiOutlined, CheckCircleOutlined } from "@ant-design/icons";

const InternetStatus = () => {

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {

    const handleOffline = () => {
      setIsOnline(false);
      notification.error({
        message: "No Internet Connection",
        description: "Please check your network. App is temporarily disabled.",
        duration: 3
      });
    };

    const handleOnline = () => {
      setIsOnline(true);
      notification.success({
        message: "Connection Restored",
        description: "You are back online.",
        icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
        duration: 3
      });
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };

  }, []);

  if (isOnline) return null;

  return (
    <div style={overlayStyle}>
      <div style={contentStyle}>
        <WifiOutlined style={{ fontSize: 40, color: "#ff4d4f", marginTop: 20 }} />
        <h2 style={{ marginTop: 15 }}>No Internet Connection</h2>
        <p>Please check your network to continue using the application.</p>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(255,255,255,0.95)",
  zIndex: 999999,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const contentStyle = {
  textAlign: "center",
};

export default InternetStatus;
